import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { StoreDetailsState } from "@core/models/store.interface";

import { Store } from "@ngrx/store";
import { selectStoreDetails } from "@shared/store/store-details/selectors";
import { take } from "rxjs";

@Component({
  selector: "app-data-limit-reached",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./data-limit-reached.component.html",
  styleUrl: "./data-limit-reached.component.scss",
})
export class DataLimitReachedComponent implements OnInit {
  storeImage: string = "/assets/carousel/pep_wifi_join.png";
  constructor(private store: Store<{ storeDetails: StoreDetailsState }>) {}

  ngOnInit(): void {
    this.getStoreDetails();
  }

  getStoreDetails() {
    this.store
      .select(selectStoreDetails)
      .pipe(take(1))
      .subscribe({
        next: (state) => {
          if (state?.storeBranding) {
            this.storeImage = state.storeBranding.joinImage;
          }
        },
      });
  }
}
